import React from 'react';

function PricingPage() {
    return <div>Pricing Page</div>;
}

export default PricingPage;
